<template>
    <b-modal
    v-model="openModal"
    :title="title"
    size="xl"
    header-bg-variant="dark"
    header-text-variant="light"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    >
    <div class="text-center my-3">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">Item</th>
                    <th scope="col">Precio</th>
                    <th scope="col">Categoria</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <b-row>
                            <b-col class="col-sm-2 d-none d-sm-block">
                                <b-img v-if="updatePriceData.item_data.imagen" :src="updatePriceData.item_data.imagen" alt="Image 1" style="max-width: 100%; max-height: 100px; object-fit: scale-down;"></b-img>
                            </b-col>
                            <b-col cols="12" md="9">
                                <div>
                                    {{updatePriceData.item_data.nombre}}
                                </div>
                                <div>
                                    <b>Item:</b> {{updatePriceData.item_data.codigo}}
                                </div>
                            </b-col>
                        </b-row>
                    </td>
                    <td>{{updatePriceData.item_data.categoria}}</td>
                    <td>
                         <b-form-input
                            v-model="updatePriceData.precio"
                            type="number"
                            autocomplete="off"
                            required
                            placeholder="Ingrese el precio"
                        ></b-form-input>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <template v-slot:modal-footer>
        <b-button size="sm" variant="danger" @click.prevent="$emit('close-modal')">
                Cancelar
        </b-button>
        <b-button size="sm" variant="success" @click.prevent="$emit('confirm-update')">
                Confirmar
        </b-button>
    </template>
    </b-modal>
</template>

<script>
export default {
    name: "UpdateItempriceModal",
    props: {
        updatePriceData: {
            type: Object
        },
        title: {
            type: String,
            default: ''
        },
        openModal: {
            type: Boolean,
            default: false
        }

    }

};

</script>
